var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('prev-next-buttons',{attrs:{"file":"首页"}},[_c('div',[_c('img',{attrs:{"src":require("@/assets/images/temp/Compress_首页.jpg")}})])]),_c('piwik',{attrs:{"title":"图片首页"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }